/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import LineChartComponent from './../Components/LineChartComponent.jsx';
import {
  getCaseMetricsEngineMetrics,
  getMetricsPageHighlights,
} from './../reducers';
import { selectJob } from './../actions';
import { metricsJobIdTooltipFooter } from './../helpers/chart';

const colorMap = {
  '$LogFile': 'rgba(73, 0, 146, 1)',
  '$MFT': 'rgba(146, 0, 0, 1)',
  'All Files and Folders': 'rgba(0, 109, 219, 1)',
  'File Slack Space': 'rgba(0, 73, 73, 1)',
  'None': 'rgba(0,0,0,1)',
  'Sector Level': 'rgba(146, 73, 0, 1)',
  'Unallocated Clusters': 'rgba(182, 109, 255, 1)',
  'Uninitialized File Area': 'rgba(219, 209, 0, 1)',
  'User Selected': 'rgba(109, 182, 255, 1)',
  'Volume Shadow Copies': 'rgba(36, 255, 36, 1)',
  'Writing Filesystem Information': 'rgba(255, 182, 119, 1)',
  'hiberfil.sys': 'rgba(182, 219, 255, 1)',
  'pagefile.sys / swapfile.sys': 'rgba(255, 255, 109, 1)',
  'Indexing': 'rgba(139, 69, 19, 1)',
  'Decrypting': 'rgba(139, 0, 139, 1)'
};

const getSeries = (timingNames, length) => {
  const pointRadius = length ? 0 : 4;
  return timingNames.map(n => {
    return {
      label: n,
      pointRadius: pointRadius,
      pointBackgroundColor: colorMap[n],
      backgroundColor: colorMap[n],
      pointBorderColor: colorMap[n],
      fill: true
    };
  });
};

const getData = (sortedNames, timings) =>
  sortedNames.map(n =>
    timings.map(t =>
      t && t[n] > 0 ?
        t[n] / 1000 :
        null
    )
  );

export const mapStateToProps = (state, ownProps) => {
  const metrics = getCaseMetricsEngineMetrics(state).filter(m => m && !m.artifactOnly);
  const timings = (ownProps.isCcf) ?
    metrics.map(m => m ? m.ccfTiming : m) :
    metrics.map(m => m ? m.ncfTiming : m);

  const timingNamesHash = {};
  if (timings && timings.length > 0)
  {
    timings.filter(t => t !== undefined)
      .forEach(t => Object.keys(t).forEach(k => timingNamesHash[k] = k));
  }
  const sortedTimingNames = Object.keys(timingNamesHash).sort();
  const highlights = getMetricsPageHighlights(state);
  return {
    stacked: ownProps.stacked,
    data: getData(sortedTimingNames, timings).filter(d => d),
    series: getSeries(sortedTimingNames, metrics.length),
    labels: metrics.map(m => m ? m.jobNumber : m),
    lines: highlights,
    options: {
      scales: { xAxes: [{ offset: true }] },
      tooltips: {
        callbacks: {
          footer: (tooltipItem) => metricsJobIdTooltipFooter(tooltipItem)(metrics)
        }
      }
    }
  };
};

export default connect(
  mapStateToProps,
  { onClick: selectJob }
)(LineChartComponent);


// WEBPACK FOOTER //
// src/Containers/CaseMetricsTimingChartContainer.jsx